import {
  SectionTitle,
  Text,
} from "../AdminDocumentManagement/AdminDocumentManagementSharedStyles";
import { Container } from "./AdminComplaintsDetailClientStyles";

function AdminComplaintsDetailClient(props) {
  const { client } = props;
  return (
    <Container>
      <div className="client-info">
        <div>
          <SectionTitle light={true}>TIPO DE DOCUMENTO</SectionTitle>
          <Text small={true}>{client.documentType}</Text>
        </div>
        <div>
          <SectionTitle light={true}>DOCUMENTO</SectionTitle>
          <Text small={true}>{client.documentNumber}</Text>
        </div>
        <div>
          <SectionTitle light={true}>TELEFONO</SectionTitle>
          <Text small={true}>{client.phoneNumber}</Text>
        </div>
        <div>
          <SectionTitle light={true}>CELULAR</SectionTitle>
          <Text small={true}>{client.cellphoneNumber}</Text>
        </div>
        <div>
          <SectionTitle light={true}>EMAIL</SectionTitle>
          <Text small={true}>{client.email}</Text>
        </div>
      </div>
      <div className="client-charge">
        <SectionTitle light={true}>CARGO</SectionTitle>
        <Text small={true}>{client.charge}</Text>
      </div>
    </Container>
  );
}

export default AdminComplaintsDetailClient;
